export default __webpack_public_path__ + "images/WP.5df35e5.png";